import { Option } from 'components_new/molecules/SelectSearch'
import { TFunction } from 'language/translator'
import type { TAttributeOptionDto } from '@homepal/api-contract'
import { TWidgetSettings, WidgetType } from 'types/GlobalWidget'

import { hasVariantOptions } from 'utils/variantOptions'

/** Why the breakdown cannot be set, or null when it can. */
export const getBreakdownDisabledText = (
  settings: TWidgetSettings,
  t: TFunction
): string | null => {
  if (hasVariantOptions(settings)) {
    return t('widgets', 'breakdown_disabled_due_to_variant_options')
  }

  if (settings.comparative_period.selected?.value) {
    return t('widgets', 'breakdown_disabled_due_to_comparative')
  }

  if (settings.horizontal && settings.type.selected === WidgetType.LIST) {
    return t('widgets', 'breakdown_disabled_due_to_horizontal_segments')
  }

  return null
}

export const getBreakdownOptions = (
  breakdownOptions: TAttributeOptionDto[],
  settings: TWidgetSettings,
  t: TFunction
): Option[] => {
  const newOptions = breakdownOptions
    .filter(
      (option) => !option.disabled && option.id !== settings.segment_by.selected
    )
    .map((option) => {
      return {
        title: option.name,
        id: option.id
      }
    })

  const defaultOptions = [
    {
      disabled: false,
      title: t('global', 'none'),
      id: 'none'
    }
  ]

  return [...defaultOptions, ...newOptions]
}
